module.exports = __webpack_public_path__ + "static/img/setup_step02@2x.f87b81f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/contactUs/establishmentProcess/setup_step02@2x.png
// module id = b5sZ
// module chunks = 0